import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import { css } from 'styled-system/css';
import { token } from 'styled-system/tokens';
import AlertIcon from '@/common/assets/icons/alert.svg?react';
import UnCompletedFilesModal from '@/modules/Dashboard/components/modals/UnCompletedFilesModal';
import useModal from '@/common/hooks/useModal';

const HomePageAlert = ({ count = 0 }: { count: number }) => {
  const { closeModal, open, openModal } = useModal();
  return (
    <>
      <CardButton
        cardProps={{
          className: css({
            marginY: '1rem',
            border: '1px solid',
            borderColor: 'orange',
          }),
          onClick: openModal,
        }}
        hasArrow
        arrowColor={token('colors.orange')}
        renderIcon={() => <AlertIcon />}
        title={`پرونده های تکمیل نشده (${count} مورد)`}
        renderTag={() => <Typography color={'orange'}>مشاهده</Typography>}
      />
      <UnCompletedFilesModal closeModal={closeModal} open={open} />
    </>
  );
};

export default HomePageAlert;
